import React from 'react'
import { Stack } from '@mui/material'
import { useWatch } from 'react-hook-form'
import { OptionalFields } from 'src/Libs/flow/components/Controls/OptionalFields'
import { ScrollRestore } from 'src/Libs/flow/components/ScrollRestore'
import { Htc320hIo } from '../components/Htc320hIo'
import { MyPvIo } from '../components/MyPvIo'
import { StorageIo } from '../components/StorageIo'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { InstallationFormModel } from 'src/Libs/flow/installation/forms'
import { BannerLocations, BannerQueue } from 'src/Libs/banners'

export const IoInterfaces: React.FC = () => {
  const { control } = useInstallationForm()
  const hasHtc320hIo = useWatch({ control, name: 'ioInterfaces.htc320h' }) !== null
  const hasStorageIo = useWatch({ control, name: 'ioInterfaces.storage' }) !== null
  const hasMypvIo = useWatch({ control, name: 'ioInterfaces.mypv' }) !== null

  return (
    <>
      <BannerQueue location={BannerLocations.FlowSettingsAdvancedSettingsIo} sx={{ mt: [2, 0], mb: [0, 2] }} />
      <Stack sx={{ gap: 2, mb: [6, 2] }}>
        <OptionalFields<InstallationFormModel> condition={hasHtc320hIo} fieldNames={['ioInterfaces.htc320h']}>
          <Htc320hIo />
        </OptionalFields>

        <OptionalFields<InstallationFormModel> condition={hasStorageIo} fieldNames={['ioInterfaces.storage']}>
          <StorageIo />
        </OptionalFields>

        <OptionalFields<InstallationFormModel> condition={hasMypvIo} fieldNames={['ioInterfaces.mypv']}>
          <MyPvIo />
        </OptionalFields>
      </Stack>

      <ScrollRestore />
    </>
  )
}
